module.exports = __webpack_public_path__ + "assets/b6c6bfc327e247d31f75e5eb151bc483.webm";


/*****************
 ** WEBPACK FOOTER
 ** C:/Users/jlondon/Desktop/Work-Resize/roc2/engine/public-src/spingames/panel/images-desktop/celebrations/coins.webm
 ** module id = 64
 ** module chunks = 0
 **/